import { IForceSyncOrderStatusRule } from '../force-sync-order-status-rule.interface';

export class InRevisionForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync(): boolean {
    return false;
  }
}
